export const DEFAULT_PAGE_SIZE = 25;
export const SMALL_PAGE_SIZE = 10;
